export const MuiCustomIcon = () => (
    <svg
        className="MuiSvgIcon-root text-left align-middle w-12"
        focusable="false"
        viewBox="0 0 24 24"
        aria-hidden="true">
        <path d="M19 13H5v-2h14v2z"></path>
    </svg>
);
